<template>
  <div class="faccontent">
    <div class="facdbody">
      <div class="title">
        <p class="wow fadeInUp">{{titlename}}</p>
<!--       -->
        <span  v-show="spantext!=''"  v-html="spantext">{{spantext}}</span>
      </div>
      <viewer :images="imgsrc">
        <div class="transitiondiv" v-for="item in imgsrc"  >
          <img v-show="item!=''" :src="item"/>
        </div>
      </viewer>
    </div>
  </div>
</template>

<script>
  import {WOW} from 'wowjs';

  export default {
    name: "facilities",
    props: ['titlename', 'spantext', 'typeid','imgsrc'],
    data(){
      return{
        imgArry:[],
      }
    },
    mounted() {
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .faccontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 5%;

      .title {
        padding-top: 4%;
        height: 30%;
        width: 100%;
        display: flex;
        /*align-items: center;*/
        flex-direction: column;
        font-size: 1.8em;
        z-index: 999;
        color: black;

        p {
          align-items: center;
          padding-bottom: 0.6%;
          font-size: 1.4em;
        }

        span {
          text-align: left;
          /*padding: 1% 0;*/
          line-height: 1.4em;
          font-size: 0.6em;
          padding-bottom: 1%;
        }
      }

      .facdbody {
        width: 85%;
        max-width: 1500px;
        float: left;

        .transitiondiv {
          padding-right: 1%;
          width: 24vh;
          height: 17vw;
          float: left;
          text-align: left;

          img {
            width: 100%;
            border: #717171 solid 1px;
            transition: all 0.6s; //设置动画执行的时间为0.6s
            cursor: pointer;
          }

          img:hover {
            transform: scale(1.02); //设置图片按照比例放大1.2倍
          }
        }
      }
    }
  }

  // 小于800px
  @media only screen and (max-width: 800px) {
    .faccontent {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-bottom: 5%;

      .title {
        padding: 4%;
        height: 30%;
        width: 100%;
        /*display: flex;*/
        align-items: center;
        flex-direction: column;
        font-size: 2em;
        z-index: 999;
        color: black;

        p {
          font-weight: bold;
          padding-bottom: 0.6%;
          font-size: 1.4em;
        }
        span {
          text-align: left;
          /*padding: 1% 0;*/
          font-size: 0.9em;
        }
      }

      .facdbody {
        width: 90%;
        .transitiondiv {
          padding-right: 1%;
          width: 24vh;
          margin: 0 auto;
          img {
            width: 100%;
            border: #717171 solid 1px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Services/sercomponents/Certificate.vue